import { render, staticRenderFns } from "./UploadKeysCategories.vue?vue&type=template&id=af721532&"
import script from "./UploadKeysCategories.vue?vue&type=script&lang=ts&"
export * from "./UploadKeysCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports